/**
 * 사용자가 직접 수정하거나 붙여넣은 셀의 우상단 모서리 표식.
 *
 * 연동 표식과 같은 크기·형태를 쓰되 주황색으로 구분한다. 둘 다 필요한 경우에는
 * IxdTable.Cell에서 연동 표식만 렌더해 초록색이 우선하도록 한다.
 */
const MARKER_SIZE = 9;

const CellManualEditMarker = () => (
  <svg
    width={MARKER_SIZE}
    height={MARKER_SIZE}
    viewBox={`0 0 ${MARKER_SIZE} ${MARKER_SIZE}`}
    className="pointer-events-none absolute right-0 top-0 z-[2] fill-[#FFB800]"
    data-manual-edit-marker
    aria-hidden
  >
    <title>직접 수정한 셀입니다.</title>
    <polygon points={`0,0 ${MARKER_SIZE},0 ${MARKER_SIZE},${MARKER_SIZE}`} />
  </svg>
);

export default CellManualEditMarker;
